import React, { useEffect } from "react";
import ReactAdapterConsumer from "../shared/components/React/ReactAdapterConsumer";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  sessionSelector,
  ssoActions
} from "@ufginsurance/sso-oidc-client-react";
import * as routes from "../constants/routes";
import NoWidthConstraintLayout from "../layout/NoWidthConstraintLayout";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { fetchProquoteManifest } from "./ProQuoteSlice";
import { useHistory } from "react-router-dom";
import HelpDeskMessage from "../help-desk/helpDeskMessage";
import "../layout/NoWidthContraintLayout.scss";

const ProQuote = ({
  token,
  agentCode,
  rehydrateSession,
  applicationId,
  canImpersonate,
  impersonateAgentRedirect
}) => {
  const envs = window.env;
  const history = useHistory();
  const dispatch = useDispatch();

  const ldClient = useLDClient();
  const ldUser = ldClient.getUser();

  const proQuoteData = useSelector(state => state.proquote);
  const manifestVersion = proQuoteData?.manifest?.version;

  useEffect(() => {
    if (!manifestVersion) {
      dispatch(fetchProquoteManifest());
    }
  }, [dispatch, manifestVersion]);

  const url = manifestVersion
    ? `${window.env.REACT_APP_UFGDIGITAL_MFE_URL}/proquote/${manifestVersion}/proquote.js`
    : null;

  // use this when running locally and running in Agent Portal locally
  //const url = manifestVersion ? "http://localhost:8081/_next/static/chunks/proquote.js" : null;

  return (
    <>
      {
        <NoWidthConstraintLayout>
          <ReactAdapterConsumer
            {...{
              token,
              agentCode,
              envs,
              rehydrateSession,
              ldUser,
              scope: "proquote",
              module: "ProquoteComponent",
              url,
              history,
              apComponents: { HelpDeskMessage },
              exitDestination: routes.COMMERCIAL_LINES,
              impersonation: {
                applicationId,
                canImpersonate,
                impersonateAgentRedirect
              }
            }}
          ></ReactAdapterConsumer>
        </NoWidthConstraintLayout>
      }
    </>
  );
};

const mapStateToProps = state => ({
  agentCode: sessionSelector.getAgentCode(state),
  token: state?.oidc?.user?.access_token,
  applicationId: sessionSelector.getApplicationId(state),
  canImpersonate: sessionSelector.canImpersonate(state)
});

const mapDispatchToProps = {
  rehydrateSession: ssoActions.rehydrateSession,
  impersonateAgentRedirect: ssoActions.impersonateAgentRedirect
};

export default connect(mapStateToProps, mapDispatchToProps)(ProQuote);
